// ============================================
// INFRASTRUCTURE - Descargas Repository
// ============================================

import { axiosClient } from './axios-client';

interface RegistrarDescargaParams {
  version: string;
  sistemaOperativo: 'windows' | 'mac' | 'linux';
}

export const descargasRepository = {
  /**
   * Registrar una descarga de la aplicación de escritorio
   * Endpoint público - envía token opcional si el usuario está logueado
   */
  async registrarDescarga(params: RegistrarDescargaParams): Promise<void> {
    await axiosClient.post('/public/descargas-app', params, {
      sendTokenToPublic: true, // 👈 Enviar token si existe, aunque sea ruta pública
    } as any);
  },
};
